<template>
  <div class="privacy-policy-page">
    <!-- Breadcrumb Section -->
    <section class="breadcrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="breadcrumb-content">
              <h1>{{ $t('menu.privacyPolicy') }}</h1>
              <BreadcrumbNav />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Privacy Policy Content -->
    <section class="privacy-content-section section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="privacy-content">
              
              <div class="policy-intro">
                <p>This Privacy Policy ("Privacy Policy") describes the data and information that Opalina Technologies ("Opalina" or "The Company" or "We" or "us" or "our") collects from and about you from the Internet and how we use that information. Our Privacy Policy is committed in respecting your privacy and your choices.</p>
              </div>

              <div class="policy-section">
                <h2>Scope</h2>
                <p>This Privacy Policy applies to this website <a href="https://www.opalina.com">www.opalina.com</a> ("Site" or "Website" or "our Website") only. This Privacy Policy applies to information as defined in the below "Personal Information" section, including through the Site, Online services or Programs. Unless otherwise mentioned, all references to in this Privacy Policy represent to that of Opalina Technologies.</p>
              </div>

              <div class="policy-section">
                <h2>Links, Third-Party Websites, and Social Media Platforms</h2>
                <p>Within our Site, there will be links to other Websites, or Social Media Platforms or Third-party Websites of whose respective Privacy Policies differ from that of ours. Hence if you are providing data in any of the Websites, Social Media Platforms, be informed that the data provided in such websites are governed by their respective Privacy Terms.</p>
              </div>

              <div class="policy-section">
                <h2>Personal Information</h2>
                <p>By "Personal Information", we mean any data that relates to an individual who may be identified with the help of the obtained information, or from a combination of a set of data and other information related to the individual, that are collected by us. In this Privacy Policy, a collective term "Information" will be used to denote either the Personal Information or any other information directly or indirectly related to the individual or combination of both. Generally, Information are collected either by us directly or collected automatically.</p>
              </div>

              <div class="policy-section">
                <h3>Information We Collect Directly</h3>
                <p>Commonly, you can browse our Website without having your Information collected directly by us. However, we collect Information from you when you:</p>
                <ul>
                  <li>Contact us</li>
                  <li>Request Information from us</li>
                  <li>Begin or Complete the application process for Employment with us</li>
                  <li>Access Opalina pages or accounts if any, on any third-party Social Media platforms such as Facebook or Twitter or LinkedIn</li>
                  <li>Provide Suggestions / Feedback / Comments to us</li>
                  <li>Interact with us for our Services</li>
                </ul>
                <p>The kind of data we collect include Name, Contact details such as email address, Postal address, Country and Phone number, Credentials such as passwords for authentication / account access, wherever applicable.</p>
              </div>

              <div class="policy-section">
                <h3>Information Collected Automatically</h3>
                
                <h4>Analytics Information:</h4>
                <p>For the purpose of Analytics and Performance enhancement, we may use third-party analytics tools, such as Google Analytics (for example), to help us measure the number of visits, average time spent on the site, site traffic, pages viewed, usage trends, Online usage pattern and similar information. These tools also collect information about your Computer or any device such as your Internet Protocol Address (IP Address), demographics, and Operating System etc. These data help us improve in our better performance of the Site.</p>
                
                <h4>Cookies:</h4>
                <p>Cookies are small text files, placed on your device, stored and retained by your browser that let us know more about your Site visit in order to make it convenient and faster, every time you visit us. We use cookies to remember your Personal Information, including your registration information. Most browsers automatically accept cookies to store preferences and settings. Also Cookies in Opalina Website help for load balancing, so that the Website runs non-stop.</p>
                
                <p>Largely, Cookies are categorized into three types. Session Cookies remain as long as the Browsing session in our Site is active, and are aimed at better User Experience while browsing. Persistent Cookies are stored on the Visitor's device even after the end of Browsing session, and are helpful for recalling preferences such as language settings, regional preferences or actions of the Visitor. Third-party Cookies are obtained from Third-party companies including the Analytics companies explained above, and Social Media platforms to show targeted and re-targeted information to the Visitors in such platforms.</p>
              </div>

              <div class="policy-section">
                <h2>How do we Use your data</h2>
                <p>We use your Personal Information, for optimizing our Business and performance of the Website. We use your Data:</p>
                <ul>
                  <li>To provide information to you in a way you would prefer</li>
                  <li>To understand your preferences of pages you visit within the Website and the frequency</li>
                  <li>To identify you if you had already communicated or contacted us</li>
                  <li>To contact you in case of any queries / feedback / suggestions provided by you</li>
                  <li>To develop or improve services based on your Interaction on our Site</li>
                  <li>To process job applications, create and manage your registrations</li>
                  <li>To provide better usability, maintenance of the website</li>
                  <li>To troubleshoot Site issues, if necessary</li>
                  <li>To enhance our Marketing efforts, and to conduct Research and Analysis</li>
                  <li>To protect the security and integrity of our Business and Site Services</li>
                </ul>
              </div>

              <div class="policy-section">
                <h2>You have the Choice in Your Information</h2>
                <p>While Opalina may ask for information from you or obtain information about you through various ways explained in the "Personal Information" Section, you always have the choice not to have your information collected by us. Following are ways in which you can control collection of your information:</p>
                
                <h3>Information We Collect Directly</h3>
                <p>At the time of registering or contacting us, when you are asked to provide personal data, you may choose not to provide, in case of privacy concerns. The data we collect is contextual, hence it is up to your discretion to provide or not provide such data. Not providing such information may result in not being able to access our services or parts of our website where necessary. This is meant purely for the Site's security.</p>
                
                <h3>Information Collected Automatically</h3>
                <p>You have the choice to set your browser to accept or reject cookies. Since every browser varies from each other, do check the respective browser "Help" sections, to learn how to change Cookie preferences. Usually Browsers let you block or delete cookies by following this path: Settings > Privacy > Cookies. Please visit the websites of the Browsers such as Microsoft Internet Explorer, Mozilla Firefox, Safari, Chrome or <a href="http://www.allaboutcookies.org" target="_blank" rel="noopener">http://www.allaboutcookies.org</a> to understand how to control your browser to accept or reject cookies.</p>
                
                <p>Also, you have the choice of opting-out of the collection of information viz Cookies from Third-party websites such as Blukai, Eloqua, DemandBase, Disqus, Adobe Analytics, Google Analytics, Facebook, LinkedIn, Twitter, YouTube, AddThis etc. Please refer the respective websites and their privacy / cookie policies to understand how these companies collect information on our behalf and also to learn how to opt out of providing your information to them.</p>
              </div>

              <div class="policy-section">
                <h2>Sharing Personal Information</h2>
                <p>We share your Personal Information with Opalina Technologies-controlled affiliates and subsidiaries. We also share the information with Contractors / Vendors / Third-parties working on our behalf for the Usage of Data mentioned in this Policy, such as Site Security management, Marketing Research etc.</p>
                
                <p>When required, Opalina discloses Personal Information to external law enforcement or regulatory authorities, in order to comply with the laws of the land. We also share the Personal Information if need arises to maintain the security of the Website, to prevent or stop attack on our networks / computer systems.</p>
              </div>

              <div class="policy-section">
                <h2>Data Retention</h2>
                <p>We retain personal information as long as it is necessary to fulfill the uses of the Personal Information listed in this Policy. If required for legal obligations, and to fulfil legitimate business purposes, the Personal Information may be retained for longer period than necessary.</p>
              </div>

              <div class="policy-section">
                <h2>Security of your Personal Information</h2>
                <p>We are committed in protection of the security of your Personal information. We engage reasonable technical, administrative and physical controls to keep your Personal Information secure. We use a variety of tools to protect your information from unauthorized sharing or disclosure or access or use. Through this Policy, we also request our Third-party service providers to employ reasonable security measures to protect information of our visitors, from unauthorized sharing, access and / or usage.</p>
                
                <p>We store and process the collected Personal Data in servers licensed by Opalina Technologies. The choice of Storage and Process methodology is based on our commitment for efficient operations, improved performance and data protection.</p>
              </div>

              <div class="policy-section">
                <h2>Contact Us</h2>
                <p>Through this Policy, we request our Visitors to notify us, if any irrelevant or unnecessary information is being asked from you through email or any other suspicious links in the name of Opalina Technologies.</p>
                
                <p>If you have this or any other privacy concern, complaint or a query regarding this Privacy Policy, please contact us in the "Contact" section.</p>
              </div>

              <div class="policy-section">
                <h2>Acceptance to this Privacy Policy</h2>
                <p>By visiting our Website and / or by using our Services, you indicate your acceptance of this Privacy Policy, and you agree to adhere to our Terms and Conditions. If you do not agree with the terms of this Privacy Policy, please do not access our Site or Services or submit any Personal information to us.</p>
              </div>

              <div class="policy-section">
                <h2>Changes to the Privacy Policy</h2>
                <p>Opalina reserves the right to modify this Privacy Policy at any time, hence you are requested to review it frequently for changes. If we make changes to this Privacy Policy, we will post such changes here in the same location of the Website. Your continued use / access of our Website and/or providing your Personal Information after such posting constitute your acceptance of such changes. Unless it materially affects the use or disclosure of your personal information, Opalina Website is in no obligation to exclusively notify to its Visitors that there are changes.</p>
              </div>

              <div class="policy-update">
                <p><em>Last Updated: {{ new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) }}</em></p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import BreadcrumbNav from '../components/BreadcrumbNav.vue'
import { useMeta } from '../composables/useMeta'
import { useSEO } from '../composables/useSEO'

// SEO Meta Tags
useMeta({
  title: 'Privacy Policy - Opalina Technologies',
  description: 'Privacy Policy for Opalina Technologies. Learn how we collect, use, and protect your personal information.',
  keywords: 'privacy policy, data protection, personal information, cookies, GDPR'
})

// Structured Data
const seoData = useSEO()

onMounted(() => {
  // Add WebPage schema
  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Privacy Policy",
    "description": "Privacy Policy for Opalina Technologies",
    "url": "https://www.opalina.com/privacy-policy",
    "publisher": {
      "@type": "Organization",
      "name": "Opalina Technologies",
      "url": "https://www.opalina.com"
    },
    "datePublished": "2025-01-01",
    "dateModified": new Date().toISOString().split('T')[0]
  }

  const script = document.createElement('script')
  script.type = 'application/ld+json'
  script.text = JSON.stringify(webPageSchema)
  document.head.appendChild(script)
})
</script>

<style scoped>
.breadcrumb-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 80px 0 60px;
  position: relative;
  overflow: hidden;
}

.breadcrumb-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('/assets/images/shapes/breadcrumb-shape.png') no-repeat center;
  background-size: cover;
  opacity: 0.1;
}

.breadcrumb-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.breadcrumb-content h1 {
  color: #fff;
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
}

.privacy-content-section {
  background: #f8f9fa;
}

.section-padding {
  padding: 80px 0;
}

.privacy-content {
  background: #fff;
  padding: 50px;
  border-radius: 10px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.08);
}

.policy-intro {
  margin-bottom: 40px;
  padding: 25px;
  background: #f0f4ff;
  border-left: 4px solid #667eea;
  border-radius: 5px;
}

.policy-intro p {
  font-size: 16px;
  line-height: 1.8;
  margin: 0;
  color: #333;
}

.policy-section {
  margin-bottom: 40px;
}

.policy-section h2 {
  color: #667eea;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}

.policy-section h3 {
  color: #764ba2;
  font-size: 22px;
  font-weight: 600;
  margin-top: 25px;
  margin-bottom: 15px;
}

.policy-section h4 {
  color: #555;
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 12px;
}

.policy-section p {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 15px;
}

.policy-section ul {
  margin: 20px 0;
  padding-left: 30px;
}

.policy-section li {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  margin-bottom: 10px;
  list-style-type: disc;
}

.policy-section a {
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s;
}

.policy-section a:hover {
  color: #764ba2;
  text-decoration: underline;
}

.policy-update {
  margin-top: 50px;
  padding-top: 30px;
  border-top: 2px solid #e9ecef;
  text-align: center;
}

.policy-update p {
  color: #888;
  font-style: italic;
  font-size: 14px;
}

/* Responsive Styles */
@media (max-width: 991px) {
  .breadcrumb-content h1 {
    font-size: 36px;
  }

  .privacy-content {
    padding: 30px;
  }

  .policy-section h2 {
    font-size: 24px;
  }

  .policy-section h3 {
    font-size: 20px;
  }
}

@media (max-width: 767px) {
  .breadcrumb-section {
    padding: 60px 0 40px;
  }

  .breadcrumb-content h1 {
    font-size: 28px;
  }

  .privacy-content {
    padding: 20px;
  }

  .policy-section h2 {
    font-size: 22px;
  }

  .policy-section h3 {
    font-size: 18px;
  }

  .policy-section p,
  .policy-section li {
    font-size: 15px;
  }
}
</style>
